/**
 * Unique keys for drawer overlays by placement.
 */
export const DRAWER_KEYS = {
  DRAWER_LEFT: 'drawer-left',
  DRAWER_RIGHT: 'drawer-right',
  DRAWER_TOP: 'drawer-top',
  DRAWER_BOTTOM: 'drawer-bottom',
} as const;

/**
 * Unique keys for modal overlays by type.
 */
export const MODAL_KEYS = {
  MODAL_BASE: 'modal-base',
  MODAL_CUSTOM: 'modal-custom',
  MODAL_VIDEO: 'modal-video',
  MODAL_GALLERY: 'modal-gallery',
  MODAL_FORM: 'modal-form',
  MODAL_LOADING: 'modal-loading',
  SHORTCUT_BUYING_TOOLS: 'shortcut-buying-tools',
  SPLASH: 'splash',
} as const;

export type ModalKey = (typeof MODAL_KEYS)[keyof typeof MODAL_KEYS];

/**
 * Combined list of all overlay keys used throughout the app.
 * Used to register, control, and type-check overlays globally.
 */
export const OVERLAY_KEYS = {
  ...DRAWER_KEYS,
  ...MODAL_KEYS,
} as const;
